import { CircularProgress, FormControl, MenuItem, Select } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../../hooks/auth';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      color: 'white'
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff'
    },
    textColor: {
      color: 'red',
      fontSize: '1.2rem',
      fontWeight: 'bold'
    }
  }),
);

export default function CompanySelector() {
  const classes = useStyles();
  const { user, view, setView } = useAuth();
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const handleChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    setOpenBackdrop(true);
    setView({ view: String(event.target.value) }).then(() => {
      setOpenBackdrop(false);
      window.location.reload()
    });
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={openBackdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <form className={classes.root} autoComplete="off">
        <FormControl className={classes.formControl}>
          <Select
            className={classes.textColor}
            value={view}
            onChange={handleChange}
            inputProps={{
              name: 'view',
              id: 'view',
            }}
          >
            {(user != undefined && user.userViews != undefined) ? user.userViews.map((entitie, index) => {
              return (
                <MenuItem className={classes.textColor} key={entitie.code} value={entitie.code}>{entitie.name}</MenuItem>
              )
            }) : ""}

          </Select>
        </FormControl>
      </form>
    </>
  );
}